import { DeadForm, SeasoningForm } from '../types/withdraw';

export function isReApp(form: DeadForm): boolean {
  return form.reason === 'Went With Another Lender' && form.reApp;
}

export function isDeadValid(form: DeadForm): boolean {
  if (!form.reason || !form.withdrawDate) return false;
  if (isReApp(form) && !form.newLender) return false;
  if (form.lenderVariant === 'nonsync') {
    return form.withdrawnWithLender && Boolean(form.lenderWithdrawDate);
  }
  return true;
}

export function isSeasoningValid(form: SeasoningForm): boolean {
  if (!form.reason || !form.suspendedUntil) return false;
  switch (form.reason) {
    case 'Rate Watch':
      return Boolean(form.currentRate && form.targetRate);
    case 'Credit Repair':
      return Boolean(form.currentScore && form.targetScore);
    case 'Forbearance':
    case 'Loan Modification':
      return Boolean(form.expectedEndDate);
    case 'Loan Seasoning':
      return Boolean(form.seasoningType && form.eligibleDate);
    default:
      return false;
  }
}
